import { replaceBackEndUrl, convertTitleToReadable } from '../api_tools'
// import jsdom from 'jsdom';
// const { JSDOM } = jsdom;

export default class ContentPage {
    fromRestData(restData) {
        this.mediaIdFull = null;
        this.mediaIdMobile = null;
        this.fullPictureUrl = null;
        this.mobilePictureUrl = null;
        this.pictureAlt = null;
        this.type = "page";
        this.id = restData.id;
        this.url = replaceBackEndUrl(restData.link);

        if(restData.acf){
            this.acf = restData.acf;
        }else{
            this.acf = null;
        }

        if(this.acf.bannerImage){
            if(this.acf.bannerImage.image){
                this.fullPictureUrl = this.acf.bannerImage.image.url;
            }
            if(this.acf.bannerImage.mobileImage){
                this.mobilePictureUrl = this.acf.bannerImage.mobileImage.url;
            }
        }

        if(this.acf && this.acf.title && this.acf.title.length > 0){
            this.h1 = this.acf.title;
        }else{
            this.h1 = restData.title.rendered;
        }

        this.title = convertTitleToReadable(restData.title.rendered);

        this.content = restData.content.rendered;

        //this.filterContent();

        if(restData.acf.bannerImage.image){
            // this.mediaIdFull = restData.acf.bannerImage.image;
            // this.mediaIdMobile = restData.acf.bannerImage.mobileImage;
            this.bgposition = "center center";

            if(restData.acf.bannerImage.imagePosition && restData.acf.bannerImage.imagePosition.length > 0){            
                let bgposition_split = restData.acf.bannerImage.imagePosition.split("_");
                this.bgposition = bgposition_split[0] + " " + bgposition_split[1];
            }
        }
    }

    setFullPictureFromRestData(mediaData){
        this.fullPictureUrl = mediaData.source_url;
        this.pictureAlt = mediaData.alt_text;
    }
    setMobilePictureFromRestData(mediaData){
        this.mobilePictureUrl = mediaData.source_url;
    }

    // filterContent(){
    //     const doc = new JSDOM('<!DOCTYPE html>'+this.content);

    //     let links = doc.window.document.getElementsByTagName("a");
        
    //     for(let i = 0; i < links.length; i++){
    //         //don't replace url if it points to backend wp's upload directory
    //         //needed if you want to link to image directly (to download map picture for example)
    //         if(links[i].href.indexOf("/wp-content/uploads/") !== -1){
    //             continue;
    //         }

    //         links[i].href = replaceBackEndUrl(links[i].href);
    //     }
        
    //     this.content = doc.window.document.getElementsByTagName("body")[0].innerHTML;
    // }
}